<div class="vertical-line"></div>



<div class=" reservation_step ">
  <ul>
    <li routerLinkActive="active" class="left-link active">

      <span>1.</span> Personal
    </li>
    <li routerLinkActive=" active">

      <span>2.</span> Conference
    </li>
    <li routerLinkActive="active">

      <span>3.</span> Accommodation
    </li>
    <li routerLinkActive="active">

      <span>4.</span> Room Choice
    </li>
    <li routerLinkActive="active">

      <span>5.</span> Tour
    </li>
    <li routerLinkActive="active" class="right-link">

      <span>6.</span> Confirm
    </li>
  </ul>
</div>

<div class="row">

  <form class="row" [formGroup]="personalInfoForm" class="personalinfo" (submit)="submitPersonalInfo()">
    <div class="form-group">
      <div class="row">
        <label>Title:</label>
        <kendo-dropdownlist [data]="title" style="width: 500px;" formControlName="title">
        </kendo-dropdownlist>
      </div>

      <div class="row">
        <label>First Names:
          <small style="color:red">*</small>
        </label>
        <span *ngIf="personalInfoForm.get('firstNames').touched && personalInfoForm.get('firstNames').invalid">
          <small style="color:red">Names are required</small>
        </span>
        <input kendoTextBox type="text" style="width: 500px;" class="input-field" formControlName="firstNames">
      </div>

      <div class="row">
        <label>Last Name:
          <small style="color:red">*</small>
        </label>
        <span *ngIf="personalInfoForm.get('lastName').touched && personalInfoForm.get('lastName').invalid">
          <small style="color:red">Last Name is required</small>
        </span>
        <input kendoTextBox type="text" style="width: 500px;" class="input-field" formControlName="lastName">
      </div>
      <div class="row">
        <label class="col-sm-4">Email:
          <small style="color:red">*</small>
        </label>
        <span *ngIf="personalInfoForm.get('email').touched && personalInfoForm.get('email').invalid">
          <small style="color:red">Email is required</small>
        </span>
        <input kendoTextBox type="text" style="width: 500px;" class="input-field" formControlName="email">
      </div>

      <div class="row">
        <label class="col-sm-4">Gender:
          <small style="color:red">*</small>
        </label>
        <div *ngIf="personalInfoForm.get('gender').touched && personalInfoForm.get('gender').invalid">
          <small style="color:red">Gender is required</small>
        </div>
        <kendo-dropdownlist [data]="gender" style="width: 500px;" formControlName="gender">
        </kendo-dropdownlist>
      </div>

      <div class="row">
        <label class="col-sm-4">Country:
          <small style="color:red">*</small>
        </label>
        <span *ngIf="personalInfoForm.get('country').touched && personalInfoForm.get('country').invalid">
          <small style="color:red">Country is required</small>
        </span>
        <kendo-dropdownlist [data]="countries" style="width: 500px;" formControlName="country">
        </kendo-dropdownlist>
      </div>

      <div class="row">
        <label>ID / Passport No.:
          <small style="color:red">*</small>
        </label>
        <span *ngIf="personalInfoForm.get('idNumber').touched && personalInfoForm.get('idNumber').invalid">
          <small style="color:red">ID Number is required</small>
        </span>
        <input kendoTextBox type="text" class="input-field" style="width: 500px;" formControlName="idNumber">
      </div>

      <div class="row">
        <label>Mobile Phone:
          <small style="color:red">*</small>
        </label>
        <span *ngIf="personalInfoForm.get('mobilePhone').touched && personalInfoForm.get('mobilePhone').invalid">
          <small style="color:red">Mobile Number is required</small>
        </span>
        <input kendoTextBox type="text" class="input-field" style="width: 500px;" formControlName="mobilePhone">
      </div>
    </div>
    <div>
      <button class="btn btn-info" [routerLink]="['/bookings']">Cancel</button>
      <button class="btn btn-success" [disabled]="personalInfoForm.invalid" type="submit">Next</button>
    </div>
  </form>

</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/personalinfo/personalinfo.component.html